// eslint-disable-next-line no-magic-numbers
export const hasChildrenIds = [0, 1] as const;

export type HasChildrenId = (typeof hasChildrenIds)[number];

export const defaultHasChildren: HasChildrenId = 0;

const hasChildrenLabels = ['いない', 'いる'] as const;

type HasChildrenLabel = (typeof hasChildrenLabels)[number];

type HasChildrenAttribute = {
  key: number;
  value: string;
  label: HasChildrenLabel;
};

export const createHasChildrenAttributes = (): HasChildrenAttribute[] => [
  {
    key: 0,
    value: '0',
    label: 'いない',
  },
  {
    key: 1,
    value: '1',
    label: 'いる',
  },
];

export const isHasChildrenId = (value: unknown): value is HasChildrenId => {
  if (typeof value !== 'number') {
    return false;
  }

  return hasChildrenIds.includes(value as HasChildrenId);
};
